"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Bid = void 0;

var validation_1 = require("../validation");

var chain_id_1 = require("./chain-id");

var listing_status_1 = require("./listing-status");

var network_1 = require("./network");

var Bid;

(function (Bid) {
  Bid.schema = {
    type: 'object',
    properties: {
      id: {
        type: 'string'
      },
      bidder: {
        type: 'string'
      },
      seller: {
        type: 'string'
      },
      price: {
        type: 'string'
      },
      fingerprint: {
        type: 'string'
      },
      status: listing_status_1.ListingStatus.schema,
      blockchainId: {
        type: 'string'
      },
      blockNumber: {
        type: 'string'
      },
      contractAddress: {
        type: 'string'
      },
      tokenId: {
        type: 'string'
      },
      network: network_1.Network.schema,
      chainId: chain_id_1.ChainId.schema,
      expiresAt: {
        type: 'integer'
      },
      createdAt: {
        type: 'integer'
      },
      updatedAt: {
        type: 'integer'
      }
    },
    required: ['id', 'bidder', 'seller', 'price', 'fingerprint', 'status', 'blockchainId', 'blockNumber', 'contractAddress', 'tokenId', 'network', 'chainId', 'expiresAt', 'createdAt', 'updatedAt']
  };
  Bid.validate = validation_1.generateValidator(Bid.schema);
})(Bid = exports.Bid || (exports.Bid = {}));